import { useAuth } from '../auth/use-auth';
import bdseLogoUrl from '../assets/bdse-logo.jpg';

/**
 * ProfileNotProvisioned landing page. AuthProvider routes here when a user has
 * a valid Supabase session but no active user_profiles row. This is the
 * provisioning gate: Supabase auth alone is not enough to access the platform.
 *
 * Admins create user_profiles rows in Supabase Studio after vetting access.
 * This page exists so that an unprovisioned user gets a clear message rather
 * than a confusing error or a blank dashboard.
 */
export function ProfileNotProvisioned() {
  const { auth, signOut } = useAuth();

  // We expect auth.status === 'unprovisioned'. Defensive fallback for email.
  const email = auth.status === 'unprovisioned' ? auth.user.email : undefined;

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="bdse-glass-card w-[460px] max-w-[92vw] px-10 pt-8 pb-7 text-center">
        <div className="-mt-1 -mb-2">
          <img
            src={bdseLogoUrl}
            alt="BD Signal Engine"
            className="mx-auto w-60 h-auto"
            style={{ mixBlendMode: 'multiply' }}
          />
        </div>

        <p className="bdse-tagline mb-4">Awaiting platform access</p>

        <p className="text-sm text-bdse-text-secondary leading-relaxed mb-3">
          Your sign-in was successful, but your account hasn&apos;t been
          provisioned for platform access yet.
        </p>

        {email && (
          <p className="text-xs text-bdse-text-tertiary mb-4 font-mono break-all">
            {email}
          </p>
        )}

        <p className="text-sm text-bdse-text-secondary leading-relaxed mb-5">
          Please contact your platform administrator to complete provisioning.
          Once your account is approved, refresh this page or sign in again.
        </p>

        <button type="button" onClick={signOut} className="bdse-btn-ghost">
          Sign out
        </button>

        <div className="mt-4 pt-3.5 border-t border-black/[0.06]">
          <p className="bdse-footnote">Ankura BD Intelligence Platform</p>
        </div>
      </div>
    </div>
  );
}
